import React from 'react';
import SortIcon from 'shared/components/Icon/icons/SortIcon';
import './SortField.scss';

export default ({ sortField, sortOrder }) => (
  <span className='c-sort-field'>
    {sortField} <SortIcon order={sortOrder} />
  </span>
);
